import React, { useState } from 'react'
import Header from '../../components/Header'
import CustomerIntelligence from './CustomerIntelligence'
import MarketIntelligence from './MarketIntelligence'
import ReportsAnalytics from './ReportsAnalytics'
import SuperAdminStaffAnalytics from './SuperAdminStaffAnalytics'
import { MarketIntelligenceProvider } from './MarketIntelligenceContext'
import { useNavigate } from 'react-router-dom'

const modules = [
    {
    id: 'reports',
    label: 'Reports &',
    sublabel: 'Analytics',
    color: {
      active: 'bg-purple-600',
      iconBg: 'bg-purple-100',
      iconText: 'text-purple-600',
      border: 'border-purple-200',
      chevron: 'text-purple-400',
    },
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
        <path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m2 14H7v-2h7zm3-4H7v-2h10zm0-4H7V7h10z"/>
      </svg>
    ),
    component: ReportsAnalytics,
  },
  {
    id: 'market',
    label: 'Market',
    sublabel: 'Intelligence',
    color: {
      active: 'bg-amber-500',
      iconBg: 'bg-amber-100',
      iconText: 'text-amber-600',
      border: 'border-amber-200',
      chevron: 'text-amber-400',
    },
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
        <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2m-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8z"/>
      </svg>
    ),
    component: MarketIntelligence,
  },
  {
    id: 'customer',
    label: 'Customer Intelligence',
    sublabel: '& Personalization',
    color: {
      active: 'bg-blue-600',
      iconBg: 'bg-blue-100',
      iconText: 'text-blue-600',
      border: 'border-blue-200',
      chevron: 'text-blue-400',
    },
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
        <path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3s1.34 3 3 3m-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5S5 6.34 5 8s1.34 3 3 3m0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5m8 0c-.29 0-.62.02-.97.05c1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5"/>
      </svg>
    ),
    component: CustomerIntelligence,
  },
  {
    id: 'staff',
    label: 'Staff',
    sublabel: 'Analytics',
    color: {
            active: 'bg-teal-600',
            iconBg: 'bg-teal-100',
            iconText: 'text-teal-600',
            border: 'border-teal-200',
            chevron: 'text-teal-400',
        },
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 12 12"><path fill="currentColor" d="M4.25 3.25a1.75 1.75 0 1 1 3.5 0a1.75 1.75 0 0 1-3.5 0m-2 2.25a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5M11 4.25a1.25 1.25 0 1 1-2.5 0a1.25 1.25 0 0 1 2.5 0M5.25 6C4.56 6 4 6.56 4 7.25V8.5a2 2 0 1 0 4 0V7.25C8 6.56 7.44 6 6.75 6zM3 7.25c0-.289.054-.565.154-.818l-1.231.33a1.25 1.25 0 0 0-.884 1.53l.194.725a2 2 0 0 0 2.45 1.414l.017-.005A3 3 0 0 1 3 8.5zM9 8.5c0 .733-.263 1.405-.7 1.927l.016.004a2 2 0 0 0 2.449-1.414l.194-.725a1.25 1.25 0 0 0-.884-1.53l-1.228-.33c.099.254.153.53.153.818z"/></svg>
    ),
    component:SuperAdminStaffAnalytics
  }
  
  
]

export default function AIAnalytics({ onGoToProfile }) {
  const [activeModule, setActiveModule] = useState('reports')

  const selected = modules.find(m => m.id === activeModule)
  const ActiveComponent = selected?.component

  return (
    <MarketIntelligenceProvider>
    <div className="flex-1 overflow-y-auto bg-gray-50">
      <Header
        title="Business Analytics"
        subtitle="AI-powered insights from your data and competitor intelligence"
         onGoToProfile={onGoToProfile}
      />

      <style>{`
        .scrollbar-hide::-webkit-scrollbar { display: none; }
        .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>

      <div className="p-8">

        <div className="flex gap-4 overflow-x-auto pb-2 -mx-8 px-8 md:mx-0 md:px-0 scrollbar-hide">
          {modules.map((mod) => {
            const isActive = activeModule === mod.id
            return (
              <button
                key={mod.id}
                onClick={() => setActiveModule(isActive ? null : mod.id)}
                className={`flex items-start justify-between gap-3 p-4 rounded-xl border-2 transition-all text-left flex-shrink-0 w-56 md:flex-1 md:w-auto
                  ${isActive
                    ? `${mod.color.active} border-transparent shadow-md`
                    : `bg-white ${mod.color.border} hover:shadow-sm`
                  }`}
              >
                <div className="flex items-start gap-3 min-w-0">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0
                    ${isActive ? 'bg-white bg-opacity-20' : mod.color.iconBg}`}
                  >
                    <span className={isActive ? 'text-white' : mod.color.iconText}>
                      {mod.icon}
                    </span>
                  </div>
                  <div className="min-w-0 pt-1.5">
                    <p className={`font-semibold text-sm leading-tight ${isActive ? 'text-white' : 'text-gray-800'}`}>
                      {mod.label}
                    </p>
                    <p className={`font-semibold text-sm leading-tight ${isActive ? 'text-white' : 'text-gray-800'}`}>
                      {mod.sublabel}
                    </p>
                  </div>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16" height="16"
                  viewBox="0 0 24 24"
                  className={`flex-shrink-0 transition-transform duration-200 mt-1.5
                    ${isActive ? 'rotate-180 text-white' : mod.color.chevron}`}
                >
                  <path fill="currentColor" d="M7 10l5 5l5-5z"/>
                </svg>
              </button>
            )
          })}
        </div>

        {selected && ActiveComponent && (
          <div>
            <div className="flex items-center gap-2 mt-3 mb-1">
              <span className={selected.color.iconText}>{selected.icon}</span>
              <h2 className="text-base font-bold text-gray-800">
                {selected.label} {selected.sublabel}
              </h2>
            </div>
            <div className="-mx-6">
              <ActiveComponent />
            </div>
          </div>
        )}
          </div>
    </div>
    </MarketIntelligenceProvider>
  )
}